import React, { useEffect, useRef, useState } from "react";
import "./ApplicantForm.css";
import "./simditor.css";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  GetReportDetail,
  GetReportTemplateById,
  UpdateReportDetail,
} from "../apis/ReportsAPI";
import { UpdateOrderStatus } from "../apis/OrderAPI";
import ImportScript from "../utils/customHooks/ImportScript";
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";

const InvestigatorReport = (props) => {
  const { user } = useSelector((state) => state.auth);
  const pdfExportComponent = useRef(null);
  var type = "";
  var id = "";
  var isDownload = false;
  var isView = false;
  var reportName = "";
  if (props.type === undefined) {
    type = getParameterByName("type");
    id = getParameterByName("id");
    if (type.includes("download")) {
      isDownload = true;
      reportName = getParameterByName("reportname");
    }
  } else {
    type = props.type;
    id = props.templateid;
    isDownload = true;
  }
  if (!type.includes("preview") && type.includes("view")) {
    isView = true;
  }

  ImportScript("jquery.min.js");
  ImportScript("module.js");
  ImportScript("hotkeys.js");
  ImportScript("simditor.js");
  ImportScript("reportscripts.js");

  const initialHtmlState = {
    content: { "form-html": "<p>Loading...</p>" },
  };

  const [htmlData, setHtmlData] = useState(initialHtmlState);
  const [reportData, setReportData] = useState([]);
  const [hideAction, setHideAction] = useState(true);
  const [orderId, setOrderId] = useState(0);
  const [previewLoaded, setPreviewLoaded] = useState(false);
  const [viewLoaded, setViewLoaded] = useState(false);
  //const [show, setShow] = useState(false);
  const alert = useAlert();

  const [showSaveLoader, setShowSaveLoader] = useState(false);
  const [showSbmtLoader, setShowSbmtLoader] = useState(false);

  const containerRef = useRef(null);

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  const footerTemplate = () => {
    const footerText = `Downloaded by: ${user.useremail} on ${
      new Date().toLocaleString() + ""
    }`;
    let watermarkText = `QCR-${
      user.useremail
    } - ${new Date().toLocaleString()}`;
    for (let i = 0; i < 100; i++) {
      watermarkText += `  QCR-${
        user.useremail
      } - ${new Date().toLocaleString()}`;
    }
    //console.log(watermarkText);
    return `<div style='position: absolute; left: 10px; top: 10px; padding: 10px; opacity: 0.3; transform: rotate(0deg);
    transform-origin: 0 100%; line-height: 80px; text-align: center; width:100%; color:#cfc9cd;'><b>${watermarkText}</b></div>`;
  };

  useEffect(() => {
    if (pdfExportComponent.current && viewLoaded && type.includes("download")) {
      setTimeout(() => {
        console.log("pdf generation started..");
        var viewWatermark = document.getElementById("customStamp");
        viewWatermark.remove();
        const container = document.body.getElementsByClassName("row")[0];

        const options = {
          paperSize: "A4",
          margin: 25,
          template: footerTemplate,
        };

        drawDOM(container, options)
          .then((group) => {
            return exportPDF(group);
          })
          .then((dataUri) => {
            saveAs(dataUri, `${reportName}.pdf`);
            setTimeout(() => {
              window.close();
            }, 500);
          });
      }, 3500);
    }
  }, [viewLoaded]);

  useEffect(() => {
    async function GetReport() {
      if (type === "preview" || type === "preview_download") {
        if (id != "0") {
          var result = await GetReportTemplateById(id);
          var html = result.data.templateHtml;
          setHtmlData({ content: { "form-html": html } });
          setHideAction(true);
          setPreviewLoaded(true);
          printWatermark();
        }
      } else if (
        type === "view" ||
        type === "view_download" ||
        type === "historic_view" ||
        type === "historic_view_download"
      ) {
        result = await GetReportDetail(id, type);
        html = result.data.template_html;
        setHtmlData({ content: { "form-html": html } });
        setOrderId(result.data.order_id_ref);
        setReportData(JSON.parse(result.data.report_data ?? "[]"));
        setHideAction(true);
        setViewLoaded(true);
        printWatermark();
      } else {
        if (type != null) {
          result = await GetReportDetail(id, null);
          html = result.data.template_html;
          setHtmlData({ content: { "form-html": html } });
          setOrderId(result.data.order_id_ref);
          setReportData(JSON.parse(result.data.report_data ?? "[]"));
          setHideAction(false);
        }
      }
    }
    GetReport();
  }, [id]);

  useEffect(() => {
    reportData.map((e, i) => {
      var elemId = Object.keys(e)[0];
      var elemValue = Object.values(e)[0];
      var elemClass = e.class;
      var elemType = e.type;
      var elemById = document.getElementById(elemId);
      var elemByValue = document.getElementById(elemValue);

      if (elemId !== "" && (elemById != null || elemByValue != null)) {
        elemValue = readactInfo(elemById, elemValue);
        if (e.type === "textarea") {
          if (elemId != "Orderedby") elemById.textContent = elemValue;
          elemById.className = elemClass;
        } else if (e.type !== "radio" && e.type !== "checkbox") {
          if (elemId !== "OrderCompletionDate") elemById.value = elemValue;
          elemById.className = elemClass;
        } else {
          if (e.type === "radio") {
            elemByValue.checked = true;
            elemByValue.className = elemClass;
          } else if (e.type === "checkbox") {
            elemById.checked = elemValue;
            elemById.className = elemClass;
          }
        }

        // Add hidden property if the element has the 'hide' class
        if (elemClass.includes("hide")) {
          elemById.hidden = true;

           // Hide the parent div or label container
        const parentDiv = elemById.closest(".report-item-info-row");
        if (parentDiv) {
          parentDiv.hidden = true;
        }
        }
      } else if (
        elemClass &&
        elemClass.includes("newr") &&
        !elemClass.includes("addmr")
      ) {
        let inputId = e.dataId;
        if (elemId.includes("heading") && !inputId.includes("null")) {
          let sectionId = inputId.substring(0, inputId.lastIndexOf("_"));
          let section = document.querySelector(`[data-class="${sectionId}"]`);
          let senstivClass = "";
          if (
            section &&
            section.className.includes("senstiv-section") &&
            type.includes("historic")
          ) {
            elemValue = "";
            senstivClass = "redact";
          }
          if (inputId.includes("dupl")) {
            let dtCount = inputId.substring(
              inputId.lastIndexOf("_") + 1,
              inputId.length
            );
            sectionId = inputId.substring(0, inputId.indexOf("_"));
            section = document.querySelector(`[data-class="${sectionId}"]`);
            section = section.querySelector(`.dupl[data-id="${dtCount}"]`);
          }
          let inptId = inputId;
          if (elemId.includes("duplinpt")) {
            let y = elemId.substring(0, elemId.indexOf("_"));
            let inptCount =
              parseInt(y.substring(y.indexOf("t") + 2, y.length) ?? "0") + 1;
            let inptIdPart = y.substring(0, y.indexOf("t") + 2);
            let inptRestPart = elemId.substring(
              elemId.indexOf("_") + 1,
              elemId.lastIndexOf("_")
            );
            inptId = `${inptIdPart}${inptCount}_${inptRestPart}`;
          }
          let new_row = `<div class="report-item-info-row dyn_${inputId}" data-id="${inputId}"><div class="report-item-info-col"><input class="form-control newr" id="${elemId}" data-id="${inputId}" value="${elemValue}" /></div><div class="report-item-info-col ${senstivClass}"><input type="text" class="form-control newr" placeholder="" id="${inptId}" value="" data-id="${inputId}"/></div><div class="report-item-action"><button type="button" class="remove-btn" id="rmvbtn${inputId}" onclick="removeRow(this)">-</button><button type="button" class="add-btn" id="addbtn${inputId}" onclick="addRow(this)">+</button></div></div>`;
          if (section != null) {
            let rw = section.querySelector(".report-item-info-table");
            if (rw != null && rw != undefined) {
              let lastrw = rw.lastElementChild;
              lastrw.insertAdjacentHTML("beforebegin", new_row);
            }
          }
        } else if (elemId.includes("headarea")) {
          let senstivClass = "";
          let sectionId = inputId.substring(0, inputId.indexOf("_"));
          let section = document.querySelector(`[data-class="${sectionId}"]`);
          if (
            section &&
            section.className.includes("senstiv-section") &&
            type.includes("historic")
          ) {
            elemValue = "";
            senstivClass = "redact";
          }
          let new_row = `<div class="report-item-info-row dyn_${sectionId}" data-id="${inputId}"><div class="report-item-info-col"><textarea id="${inputId}_headarea" class="form-control newr" data-id="${inputId}">${elemValue}</textarea></div><div class="report-item-info-col ${senstivClass}"><textarea class="form-control newr" id="${inputId}" data-id="${inputId}"></textarea></div><div class="report-item-action"><button type="button" class="remove-btn" id="rmvbtn${inputId}" onclick="removeRow(this)">-</button></div></div>`;
          if (section != null) {
            let lastrw = section.getElementsByClassName(
              "report-item-info-table"
            )[0].lastElementChild;
            lastrw?.insertAdjacentHTML("beforebegin", new_row);
          }
        } else {
          if (elemById != null) elemById.value = elemValue;
        }
      } else if (
        elemClass &&
        elemClass.includes("addmr") &&
        !elemClass.includes("hide")
      ) {
        let inputId = e.dataId;
        let senstivClass = "";
        let elemSection = document;
        if ((inputId.match(/_/g) || []).length > 0) {
          let xdc = elemId.substring(elemId.indexOf("_") + 1, elemId.length);
          let dc = xdc.substring(0, xdc.indexOf("_"));
          let duplc = xdc.substring(xdc.lastIndexOf("_") + 1, xdc.length);
          if (isNaN(dc) && !dc.includes("dupl"))
            elemSection = document.querySelector(
              `[data-class='${dc}'] .dupl[data-id='${duplc}']`
            );
          inputId = inputId.substring(0, inputId.indexOf("_"));
          let section = document.querySelector(`[data-class='${dc}']`);
          if (
            section &&
            section.className.includes("senstiv-section") &&
            type.includes("historic")
          ) {
            elemValue = "";
            senstivClass = "redact";
          }
        }
        if (elemClass.includes("newr") && inputId.indexOf("_") != -1)
          inputId = inputId.substring(0, inputId.indexOf("_"));
        var dynRowsCount = elemSection.querySelectorAll(
          `.dyn_${e.dataId}:not([hidden])`
        ).length;
        if (dynRowsCount == 0) {
          var rw = elemSection.querySelector(`[data-id="${inputId}"]`);
          if (
            rw != undefined &&
            rw
              .closest(".report-item-info")
              .className.includes("senstiv-section") &&
            type.includes("historic")
          ) {
            senstivClass = "redact";
            elemValue = "";
          }
          if (rw != null && rw != undefined) {
            var clnrw = rw.cloneNode(true);
            if (rw.getElementsByClassName("add-btn")[0] != undefined)
              rw.getElementsByClassName("add-btn")[0].remove();
            if (rw.getElementsByClassName("remove-btn")[0] != undefined)
              rw.getElementsByClassName("remove-btn")[0].remove();
          }
        } else {
          rw = elemSection.querySelectorAll(`.dyn_${e.dataId}:not([hidden])`)[
            dynRowsCount - 1
          ];
          if (rw != null) {
            clnrw = rw.cloneNode(true);
            if (
              rw
                .closest(".report-item-info")
                .className.includes("senstiv-section") &&
              type.includes("historic")
            ) {
              senstivClass = "redact";
              elemValue = "";
            }
            if (
              (elemClass.includes("newr") ||
                (elemClass.includes("addmr") && e.dataId.includes("dupl"))) &&
              !elemClass.includes("hide") &&
              dynRowsCount == 1
            )
              rw.getElementsByClassName("remove-btn")[0].remove();
            rw.getElementsByClassName("add-btn")[0].remove();
          }
        }
        if (clnrw != null) {
          clnrw.classList.add("dyn_" + e.dataId);
          clnrw.setAttribute("data-id", e.dataId);
          clnrw.setAttribute("data-count", dynRowsCount + 1);
          if (elemClass.includes("newr")) clnrw.firstChild.innerHTML = "";
          else {
            if (
              clnrw.firstChild.tagName == undefined &&
              clnrw.firstChild.nextElementSibling != undefined
            )
              clnrw.firstChild.nextElementSibling.innerHTML = "";
            else clnrw.firstChild.innerHTML = "";
          }
          clnrw.getElementsByTagName("input")[0].id = elemId;
          clnrw.getElementsByTagName("input")[0].className = elemClass;
          if (senstivClass != "")
            clnrw
              .getElementsByTagName("input")[0]
              .closest(".report-item-info-col")
              .classList.add(senstivClass);
          //clnrw.getElementsByTagName("input")[0].classList.add("addmr");
          clnrw
            .getElementsByTagName("input")[0]
            .setAttribute("data-id", e.dataId);
          clnrw.getElementsByTagName("input")[0].value = elemValue;
          clnrw.getElementsByClassName("add-btn")[0].id = "addbtn" + elemId;
          clnrw.getElementsByClassName("remove-btn")[0].id = "rmvbtn" + elemId;
          rw.insertAdjacentElement("afterend", clnrw);
        }
      } else if (
        elemClass &&
        (elemClass.includes("newblk_cmn") || elemClass.includes("newblk_msg"))
      ) {
        let dataId = e.dataId;
        let dtCount = elemId.substring(
          elemId.lastIndexOf("_") + 1,
          elemId.length
        );
        let clsId = dataId.substring(0, dataId.lastIndexOf("_"));
        if (document.querySelector(`[data-class="${clsId}"]`) == null)
          clsId = dataId;
        var duplDiv = document
          .querySelector(`[data-class="${clsId}"]`)
          ?.getElementsByClassName("dupl");
        if (duplDiv && duplDiv.length == 0) {
          let firstDupl = duplDiv[0];
          let lastDupl = duplDiv[duplDiv.length - 1];
          var clnDuplDiv = firstDupl.cloneNode(true);
          let newAddition = clnDuplDiv.querySelectorAll("table[data-count]");
          if (newAddition.length > 0)
            newAddition.forEach((newadd) => newadd.remove());
          else {
            //console.log(clnDuplDiv);
            let rws = clnDuplDiv.querySelectorAll(".report-item-info-row");
            for (let i = 0; i < rws.length; i++) {
              let dtid = rws[i].getAttribute("data-id");
              let actbts = `<button type="button" class="remove-btn" id="rmvbtn${dtid}_${i}${dtCount}" onclick="removeRow(this)">-</button><button type="button" class="add-btn" id="addbtn${dtid}_${i}${dtCount}" onclick="addRow(this)">+</button>`;
              let actdiv = rws[i].querySelector(".report-item-action");
              if (actdiv.childElementCount == 0 && dtid != null)
                actdiv.innerHTML = actbts;
            }
          }
          let newInpts = clnDuplDiv.querySelectorAll(
            "[class*='new'], input[class*='addmr']"
          );
          //console.log(newInpts);
          newInpts.forEach((elem) => {
            let row = elem.closest(".report-item-info-row");
            if (row != null) row.remove();
            else {
              row = elem.closest("tr");
              if (row != null) row.remove();
            }
          });
          if (
            clnDuplDiv &&
            clnDuplDiv.getElementsByClassName("delete-block").length > 0
          ) {
            clnDuplDiv.getElementsByClassName("delete-block")[0].remove();
          }
          var rmvBtn =
            '<div class="delete-block"><button type="button" class="btn" onclick="removeDuplicateBlock(this)">x</button></div>';
          clnDuplDiv.insertAdjacentHTML("afterBegin", rmvBtn);
          clnDuplDiv.setAttribute("data-id", dtCount);
          var divs = clnDuplDiv.querySelectorAll(
            "div:not([class='report-item-action']):not([class='delete-block'])"
          );
          let initialMsg = 0;
          for (let i = 0; i < divs.length; i++) {
            let inputCount =
              divs[i].querySelectorAll("div .form-control").length;
            if (inputCount > 0) {
              let dtCls = divs[i].getAttribute("data-class");
              if (dtCls != null)
                divs[i].setAttribute("data-class", `${dataId}`);
              var tbls = divs[i].getElementsByTagName("table");
              if (tbls.length > 0) {
                for (let k = 0; k < tbls.length; k++) {
                  tbls[k].className = tbls[k].className.replace(
                    /\bdyn.*?\b/g,
                    ""
                  );
                  tbls[k].classList.add(`dyn_${dataId}`);
                  tbls[k].setAttribute("data-count", k);
                  let tblbd = tbls[k].querySelector("tbody");
                  tblbd.setAttribute("data-id", `${dataId}`);
                  let inpts = tbls[k].getElementsByTagName("input");
                  for (let j = 0; j < inpts.length; j++) {
                    if (inpts[j].className.includes("table-th"))
                      inpts[j].id = `hdr_${dataId}-${k}-${j}`;
                    else inpts[j].id = `tbl${j}_${dataId}-${k}`;
                    inpts[j].setAttribute("data-id", `${dataId}-${k}`);
                    let tbd = inpts[j].closest("tr").closest("tbody");
                    if (tbd != null) {
                      inpts[j].closest("tr").className = `dyn_${dataId}`;
                      tbd.setAttribute("data-id", `${dataId}-${k}`);
                    }
                  }
                }
              } else if (divs[i].className.includes("report-item-info-msg")) {
                let inpts = divs[i].getElementsByTagName("input");
                for (let j = 0; j < inpts.length; j++) {
                  if (!inpts[j].className.includes("newr")) {
                    if (initialMsg === 0) {
                      inpts[j].classList.add("newblk_msg");
                      initialMsg = 1;
                    }
                    inpts[j].id = `msg${i}${j}_${dataId}`;
                    inpts[j].setAttribute("data-id", dataId);
                    if (elemClass.includes("newblk_msg"))
                      inpts[j].value = elemValue;
                  }
                }
                let txtar = divs[i].getElementsByTagName("textarea");
                for (let j = 0; j < txtar.length; j++) {
                  if (initialMsg === 0) {
                    txtar[j].classList.add("newblk_msg");
                    initialMsg = 1;
                  }
                  txtar[j].id = `txtar${i}${j}_${dataId}`;
                  txtar[j].setAttribute("data-id", dataId);
                }
              } else if (divs[i].className.includes("report-item-info-table")) {
                let inpts = divs[i].getElementsByTagName("input");
                for (let k = 0; k < inpts.length; k++) {
                  if (!inpts[k].className.includes("newr")) {
                    if (k == 0 && initialMsg === 0) {
                      inpts[k].classList.add("newblk_cmn");
                      initialMsg = 1;
                    }
                    inpts[k].id = `inpt${i}${k}_${dataId}`;
                    inpts[k].setAttribute("data-id", dataId);
                    if (elemClass.includes("newblk_cmn") && k == 0)
                      inpts[k].value = elemValue;
                  }
                }

                let btns = divs[i].querySelectorAll("button");

                btns.forEach((elem) => {
                  let btnId = `${elem.id}_${dtCount}`;
                  elem.id = btnId;
                });
              }
            }
          }
          lastDupl.insertAdjacentElement("afterend", clnDuplDiv);
        }
      } else if (elemClass && elemClass.includes("newtbl")) {
        if (elemClass.includes("table-th")) {
          let dataId = e.dataId;
          let mainDataId = dataId.substring(0, dataId.lastIndexOf("-"));
          let tblCount = dataId.substring(
            dataId.indexOf("-") + 1,
            dataId.length
          );
          let tblId = mainDataId;
          if (
            document.querySelector(
              `.report-item-info-table[data-class="${mainDataId}"]`
            ) == null
          )
            mainDataId = dataId;
          let tbl = document
            .querySelector(
              `.report-item-info-table[data-class="${mainDataId}"]`
            )
            .getElementsByTagName("table")[0];
          let clnTbl = tbl.cloneNode(true);
          clnTbl.classList.add(`dyn_${tblId}`);
          clnTbl.setAttribute("data-count", tblCount);

          let rmvbtn =
            '<button type="button" class="remove-btn" onclick="removeTable(this)">x</button>';
          let tblHead = clnTbl.getElementsByTagName("thead")[0];
          if (tblHead) {
            tblHead.getElementsByClassName("report-item-action")[0].innerHTML +=
              rmvbtn;
            let heads = tblHead.getElementsByTagName("th");
            for (let i = 0; i < heads.length; i++) {
              let inpt = heads[i].getElementsByTagName("input")[0];
              if (inpt != undefined) {
                if (i == 0) {
                  inpt.id = elemId;
                  inpt.className = elemClass;
                } else inpt.id = `hdr_${dataId}-${i}`;
                inpt.value = elemValue;
                inpt.setAttribute("data-id", dataId);
              }
            }
            let tbody = clnTbl.getElementsByTagName("tbody")[0];
            tbody.setAttribute("data-id", `${dataId}`);
            tbody.innerHTML = "";
            document
              .querySelector(
                `.report-item-info-table[data-class="${mainDataId}"]`
              )
              .appendChild(clnTbl);
          }
        } else if (elemClass.includes("taddrw")) {
          let dataId = e.dataId;
          let tbody = document.querySelector(`tbody[data-id='${dataId}']`);
          if (tbody == null) {
            let exct_dataId = dataId.substring(0, dataId.indexOf("-"));
            tbody = document.querySelector(`tbody[data-id='${exct_dataId}']`);
          }
          let rw_count = tbody.getElementsByTagName("tr").length;
          let addElem = `<button type="button" class="add-btn" id="add${dataId}${rw_count}" onclick="addTableRow(this)">+</button>`;
          let rmvElem = `<button type="button" class="remove-btn" id="rmv${dataId}${rw_count}" onclick="removeTableRow(this)">-</button>`;
          let rw_class = "";
          if (rw_count == 0) rmvElem = "";
          if (rw_count == 1) {
            rw_class = `dyn_${dataId}`;
            tbody
              .querySelector("tr[data-count='0']")
              .lastElementChild.querySelector(".report-item-action").innerHTML =
              "";
          }
          if (rw_count > 1) {
            rw_class = `dyn_${dataId}`;
            tbody
              .querySelector(`tr[data-count='${rw_count - 1}']`)
              ?.lastElementChild.getElementsByClassName("add-btn")[0]
              .remove();
          }
          let nw_rw = "";
          if (elemType == "textarea") {
            nw_rw = `<tr class="${rw_class}" data-count="${rw_count}"><td><textarea class="${elemClass}" id="${elemId}" data-id="${dataId}">${elemValue}</textarea></td><td><div class="report-item-action">${rmvElem}${addElem}</div></td></tr>`;
          } else {
            nw_rw = `<tr class="${rw_class}" data-count="${rw_count}"><td><input class="${elemClass}" id="${elemId}" value="${elemValue}" data-id="${dataId}" /></td><td><div class="report-item-action">${rmvElem}${addElem}</div></td></tr>`;
          }
          //console.log(nw_rw);
          tbody.insertAdjacentHTML("beforeend", nw_rw);
        } else {
          let dataId = e.dataId;
          let tbody = document.querySelector(`tbody[data-id='${dataId}']`);
          if (tbody == null) {
            let exct_dataId = dataId.substring(0, dataId.indexOf("-"));
            tbody = document.querySelector(`tbody[data-id='${exct_dataId}']`);
          }
          let lastrw = tbody.lastElementChild.lastElementChild;
          let td = "";
          if (elemType == "textarea") {
            td = `<td><textarea class="${elemClass}" id="${elemId}" data-id="${dataId}" >${elemValue}</textarea></td>`;
          } else {
            td = `<td><input class="${elemClass}" id="${elemId}" value="${elemValue}" data-id="${dataId}" /></td>`;
          }
          lastrw.insertAdjacentHTML("beforeBegin", td);
        }
      } else if (elemClass && elemClass.includes("newbl")) {
        let dataId = e.dataId;
        let dtclass = dataId;
        let subsec = dataId.replace(/_/g, "-");
        let dtcls = elemId.substring(0, elemId.lastIndexOf("_"));
        let rw = document.querySelector(`[data-class="${dtclass}"]`);
        let senstivClass = "";
        if (
          rw
            .closest(".report-item-info")
            .className.includes("senstiv-section") &&
          type.includes("historic")
        ) {
          senstivClass = "redact";
        }
        let block = `<div class="report-item-info ${subsec} dyn_${dataId}_block" data-class="${dtcls}"><div class="report-item-info-msg2"><input type="text" class="form-control newbl" placeholder="ABC BANK" id="${dtcls}_subheading" value="${elemValue}" data-id="${dataId}" /><button type="button" class="remove-btn" id="rmv${dtcls}_hdng" onclick="removeRow(this)">-</button></div><div class="report-item-info-table"><div class="report-item-info-row dyn_${dtcls}" data-id="${dtcls}"><div class="report-item-info-col"><input id="${dtcls}_heading" class="form-control" value="" data-id="${dtcls}"/></div><div class="report-item-info-col ${senstivClass}"><input type="text" class="form-control" placeholder="" id="${dtcls}_input" value="" data-id="${dtcls}" /></div><div class="report-item-action"><button type="button" class="remove-btn" id="rmv${dtcls}_input" onclick="removeRow(this)">-</button><button type="button" class="add-btn" id="add${dtcls}_input" onclick="addRow(this)">+</button></div></div><div class="report-item-info-row"><div class=""><a href="javascript:void(0)" onclick="addNewRow(this,'input')">Add More</a></div><div class="report-item-info-col"></div><div class="report-item-action"></div></div> </div></div>`;

        if (dtclass.includes("-"))
          dtclass = dtclass.substring(0, dtclass.indexOf("-"));
        rw.insertAdjacentHTML("beforebegin", block);
      }
    });
    if (reportData.length > 0) {
      autoEnableElements();
      //removeBlankInputFields();
      toggleInputs();
    }
    if (props.type != undefined) {
      props.viewLoaded(viewLoaded);
    }
  }, [reportData, reportData.length]);

  useEffect(() => {
    if (htmlData != initialHtmlState && reportData.length === 0) {
      autoEnableElements();
      //removeBlankInputFields();
      if (props.type != undefined) props.previewLoaded(previewLoaded);
    }
    readonlyInputs();
  }, [htmlData, initialHtmlState, reportData.length]);

  function autoEnableElements() {
    const container = containerRef.current;
    const inputs = container.getElementsByTagName("input");
    for (var i in inputs) {
      if (inputs[i].type == "radio") {
        let id = inputs[i].id;
        var inputs2 = document.getElementsByClassName(id);
        if (inputs2.length > 0) {
          for (var j in inputs2) {
            var id2 = inputs2[j].id;
            if (id2 !== undefined) {
              if (inputs[i].checked)
                document.getElementById(id2).disabled = false;
              else {
                document.getElementById(id2).value = "";
                document.getElementById(id2).disabled = true;
              }
            }
          }
        }
      } else if (inputs[i].type == "checkbox") {
        let id = inputs[i].id;
        let chk = document.getElementById(id).checked;
        let section = document
          .getElementById(id)
          .closest(".check-enable-section");
        if (section) {
          let inpts = section.getElementsByClassName("form-control");
          //console.log(inpts, chk);
          for (let i = 0; i < inpts.length; i++) {
            inpts[i].disabled = !chk;
          }
        }
      }
    }

    /*mandatory sections*/
    let mandtrys = document.querySelectorAll(".mand-section");
    mandtrys.forEach((section) => {
      let inpts = section.querySelectorAll(".form-control");
      inpts.forEach((elem) => (elem.disabled = false));
    });
  }

  function GetReportData() {
    const container = containerRef.current;
    const inputElem = container.querySelectorAll(
      ".form-control,.form-check-input"
    );
    var reportData = [];
    for (let indx = 0; indx < inputElem.length; indx++) {
      let row_hidden = false;
      if (inputElem[indx].tagName == "INPUT") {
        let rw = inputElem[indx].closest(".report-item-info-row");
        if (rw != null && rw != undefined) row_hidden = rw.hidden;
        // if (!row_hidden) {
        var elemId = inputElem[indx].id;
        var elemName = inputElem[indx].name;
        var elemValue = inputElem[indx].value;
        var elemType = inputElem[indx].type;
        var rmvClass = elemValue == "" && !row_hidden ? ` type-${type}` : "";
        if (rmvClass != "") inputElem[indx].classList.remove(rmvClass.trim());
        var elemClasses = inputElem[indx].classList.value;
        elemClasses += rmvClass;
        if (row_hidden) elemClasses += " hide";
        var dataId = inputElem[indx].getAttribute("data-id");
        if (elemId != "" && elemClasses.includes("form-")) {
          if (elemType !== "radio" && elemType !== "checkbox") {
            var inputObj = {
              [elemId]: elemValue,
              type: elemType,
              class: elemClasses,
              dataId: dataId,
            };
            reportData.push(inputObj);
          } else {
            if (elemType === "radio") {
              if (inputElem[indx].checked) {
                inputObj = {
                  [elemName]: elemId,
                  type: elemType,
                  class: elemClasses,
                  dataId: dataId,
                };

                reportData.push(inputObj);
              }
            } else if (elemType === "checkbox") {
              inputObj = {
                [elemId]: inputElem[indx].checked,
                type: elemType,
                class: elemClasses,
                dataId: dataId,
              };

              reportData.push(inputObj);
            }
          }
        }
      } else if (inputElem[indx].tagName == "TEXTAREA") {
        let txtAreaElem = inputElem[indx];
        elemId = txtAreaElem.id;
        elemValue = txtAreaElem.value;
        elemType = "textarea";
        rmvClass = elemValue == "" ? ` type-${type}` : "";
        elemClasses = txtAreaElem.classList.value;
        elemClasses += rmvClass;
        dataId = txtAreaElem.getAttribute("data-id");
        if (elemClasses.includes("form")) {
          inputObj = {
            [elemId]: elemValue,
            type: elemType,
            class: elemClasses,
            dataId: dataId,
          };
          reportData.push(inputObj);
        }
      }
    }
    return reportData;
  }

  async function saveReport(mode) {
    var data = {
      id: id,
      totalRows: 0,
      reportId: 0,
      orderId: 0,
      customerName: "",
      requestorName: "",
      applicantName: "",
      completionDate: "",
      reportData: JSON.stringify(GetReportData()),
    };
    var result = await UpdateReportDetail(data);
    if (result.status === 200) {
      let succsMsg =
        mode === "submit" ? "Submitting..." : "Report successfully saved";
      alert.success(succsMsg, {
        onOpen: () => {
          if (type === "start") UpdateOrderStatus(orderId, "6", user.userid);
        },
        onClose: () => {
          if (mode == "submit") {
            let title =
              type === "initial_qa"
                ? "Initial Report Review"
                : type === "complete"
                ? "Complete Report"
                : type === "prelim"
                ? "Prelim Report"
                : type === "reopen_qa"
                ? "Complete Reopen Report"
                : "Prelim Report Review";
            let msg =
              type === "complete"
                ? "Are you sure want to complete the report?"
                : type === "prelim"
                ? "Are you sure want to submit prelim report?"
                : type === "reopen_qa"
                ? "Are you sure want to submit reopened report?"
                : "Are you sure want to submit your review for the report?";
            let orderstatus =
              type === "initial_qa"
                ? "10"
                : type === "complete"
                ? "3"
                : type === "prelim"
                ? "7"
                : type === "reopen_qa"
                ? "14"
                : "12";
            let successmsg =
              type === "initial_qa"
                ? "Report initial review submitted."
                : type === "complete"
                ? "Complete report submitted"
                : type === "prelim"
                ? "Prelim report submitted"
                : type === "reopen_qa"
                ? "Reopened report sumitted"
                : "Prelim report review submitted";
            let errormsg = "Unable to mark report as reviewed.";

            confirmAlert({
              title: title,
              message: msg,
              buttons: [
                {
                  label: "Yes",
                  className: "yesbtn",
                  onClick: async () => {
                    mode == "submit"
                      ? setShowSbmtLoader(true)
                      : setShowSaveLoader(true);
                    var rslt = await UpdateOrderStatus(
                      orderId,
                      orderstatus,
                      user.userid
                    );
                    if (rslt.status === 200)
                      alert.success(successmsg, {
                        onClose: () =>
                          mode == "submit"
                            ? setShowSbmtLoader(false)
                            : setShowSaveLoader(false),
                      });
                    else
                      alert.error(errormsg, {
                        onClose: () =>
                          mode == "submit"
                            ? setShowSbmtLoader(false)
                            : setShowSaveLoader(false),
                      });
                  },
                },
                {
                  label: "No",
                  className: "nobtn",
                },
              ],
            });
          }
        },
      });
    } else alert.error("Unable to save report");
  }

  function removeBlankInputFields() {
    let inpts = document.querySelectorAll("input.form-control.hide");
    inpts.forEach((elem) => {
      if (elem.value == "" || elem.className.includes("hide")) {
        let nearestElem = elem.closest(".report-item-info-row");
        if (nearestElem != null) nearestElem.hidden = true;
      }
    });
  }

  function toggleInputs() {
    var chkboxes = document.querySelectorAll(".form-check-input");
    chkboxes.forEach((cb) => {
      if (cb.className.includes("main-check")) {
        let chk = cb.checked;
        let section = cb.closest(".check-enable-section");
        let inpts = section.querySelectorAll(".form-control");
        inpts.forEach((inpt) => {
          inpt.disabled = !chk;
        });
      }
    });
    for (let i = 0; i < chkboxes.length; i++) {
      if (!chkboxes[i].classList.contains("main-check")) {
        var chk = chkboxes[i].checked;
        var click_func = chkboxes[i].getAttribute("onclick");
        if (click_func != undefined) {
          var clk = click_func.substring(
            click_func.indexOf(",") + 1,
            click_func.length
          );
          var first_arg = clk.substring(0, clk.indexOf(",")).replace(/'/g, "");
          var second_arg = clk
            .substring(clk.indexOf(",") + 1, clk.length - 1)
            .replace(/'/g, "");
        }
        var section = chkboxes[i].closest(".check-enable-section");
        if (!section) continue;
        if (second_arg != undefined && second_arg.trim() != "className") {
          section = section.querySelector(`[data-class="${first_arg}"]`);
        } else section = section.getElementsByClassName(`${first_arg}`);

        if (second_arg != undefined && second_arg.trim() != "className") {
          toggleButtons(section, chk);
          let inputs = section.getElementsByClassName("form-control");
          for (let i = 0; i < inputs.length; i++) {
            inputs[i].disabled = !chk;
          }
        } else {
          for (let i = 0; i < section.length; i++) {
            toggleButtons(section[i], chk);
            let inputs = section[i].getElementsByClassName("form-control");
            for (let j = 0; j < inputs.length; j++) {
              inputs[j].disabled = !chk;
            }
          }
        }
      }
    }
  }

  function toggleButtons(section, chk) {
    if (section != null) {
      let anchors = section.getElementsByTagName("a");
      for (let i = 0; i < anchors.length; i++) {
        if (chk) {
          anchors[i].style.pointerEvents = "auto";
          anchors[i].style.cursor = "pointer";
        } else {
          anchors[i].style.pointerEvents = "none";
          anchors[i].style.cursor = "default";
        }
      }
    }
  }

  function readonlyInputs() {
    if (type.includes("view")) {
      var inpts = document.querySelectorAll(".form-control");
      inpts.forEach((elem) => (elem.readOnly = true));
    }
  }

  function printWatermark() {
    var textWatermark = `QCR-${user.useremail}`;
    var fullTextWatermark = "";
    var n = 10000;
    for (var i = 0; i < n; i++) {
      fullTextWatermark += " " + textWatermark;
    }
    document.getElementById("customStamp").innerHTML = fullTextWatermark;
  }

  function readactInfo(elemById, elemValue) {
    if (type.includes("historic")) {
      if (elemById.parentElement.className.includes("senstiv-top")) {
        elemValue = "";
        elemById.parentElement.classList.remove("senstiv-top");
        elemById.parentElement.classList.add("redact-top");
      } else if (elemById.parentElement.className.includes("senstiv")) {
        elemValue = "";
        elemById.parentElement.classList.remove("senstiv");
        elemById.parentElement.classList.add("redact");
      } else if (elemById.closest(".report-item-info") != null) {
        if (
          elemById
            .closest(".report-item-info")
            .className.includes("senstiv-section")
        ) {
          elemValue = "";
          elemById.closest(".report-item-info-col")?.classList.add("redact");
        }
      }
    }
    return elemValue;
  }

  return (
    <>
      <div className="container" ref={pdfExportComponent}>
        <div className="row">
          <div className="col-lg-12">
            <div id="customStamp"></div>
            <div
              className={`abstract-request
                ${isDownload ? " download-report watermark" : ""} ${
                isView ? " view-report watermark" : ""
              }`}
              ref={containerRef}
              dangerouslySetInnerHTML={{
                __html: htmlData?.content?.["form-html"],
              }}
            ></div>
            <div className={isDownload ? "pdf-footer d-flex" : "pdf-footer"}>
              <div className="pdf-downloaded-by">
                Downloaded by: {user.useremail}
              </div>
              <div className="pdf-downloaded-date">
                Date: {new Date().toLocaleString() + ""}
              </div>
            </div>
          </div>
          <div
            className={
              hideAction
                ? "text-center form-action-btn-hide"
                : "text-center form-action-btn"
            }
          >
            {type === "prelim" || type === "complete" ? (
              <>
                <button
                  type="button"
                  className="btn form-save-btn"
                  onClick={() => saveReport()}
                >
                  Save
                  <Loader visible={showSaveLoader} ibutton={true} />
                </button>{" "}
                <button
                  type="button"
                  className="btn form-save-btn"
                  onClick={() => saveReport("submit")}
                >
                  {type === "prelim"
                    ? "Submit Prelim Report"
                    : "Submit Complete Report"}
                  <Loader visible={showSbmtLoader} ibutton={true} />
                </button>
              </>
            ) : type.includes("qa") ? (
              <>
                <button
                  type="button"
                  className="btn form-save-btn"
                  onClick={() => saveReport()}
                >
                  Save
                  <Loader visible={showSaveLoader} ibutton={true} />
                </button>{" "}
                <button
                  type="button"
                  className="btn form-save-btn"
                  onClick={() => saveReport("submit")}
                >
                  {type.includes("reopen") ? "Submit" : "Submit Review"}
                  <Loader visible={showSbmtLoader} ibutton={true} />
                </button>
              </>
            ) : (
              <button
                type="button"
                className="btn form-save-btn"
                onClick={() => saveReport()}
              >
                Save
                <Loader visible={showSaveLoader} ibutton={true} />
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InvestigatorReport;
